export default __webpack_public_path__ + "static/media/sky.2058c205.svg";